export const calculateRetardationFromSlope = ({retardation, slope, initialSpeed, finalSpeed}) => {
    const dx = 0.1;
    let result = [
        {
            speed: initialSpeed,
            distance: 0,
        }
    ];

    while(result[result.length-1].speed > finalSpeed)
    {
        const distance = result[result.length-1].distance + dx;
        result.push({
            distance: distance,
            speed: Math.sqrt(initialSpeed**2 - 25.92 * distance * (9.81 * slope + retardation))
        });
    }

    return result;
}